import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { withdrawService } from "../../services/WithdrawalServices";

const WithdrawalDetails = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [withdrawalRequest, setWithdrawalRequest] = useState("");
  const [status, setStatus] = useState("");
  const [amount, setAmount] = useState("");

  const { id } = useParams();

  useEffect(() => {
    if (id) fetchWithdrawalDetails();
  }, [id]);

  const fetchWithdrawalDetails = async () => {
    try {
      const response = await withdrawService.withdrawalDetails(id);
      if (response.status === 200) {
        const data = response.data.data;
        setUsername(data.username);
        setEmail(data.email);
        setPhoneNumber(data.phoneNumber);
        setWalletAddress(data.wallet_address);
        setWithdrawalRequest(data.withdrawal_request);
        setStatus(data.status);
        setAmount(data.amount);
      } else {
        toast.error(response?.data?.message || "Failed to fetch details.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    }
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleUpdateStatus = async () => {
    try {
      const payload = { status };
      const response = await withdrawService.withdrawalStatus(id, payload);
      if (response.status === 200) {
        toast.success("Status updated successfully.");
      } else {
        toast.error(response?.data?.message || "Failed to update status.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    }
  };

  return (
    <>
      <div className="body-header border-bottom d-flex py-3">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col-xl-12">
              <h1 className="h4 mt-1">Withdrawal Details</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="body d-flex py-3">
        <div className="container-xxl">
          <div className="row mb-3">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3 row-cols-1 row-cols-sm-2 row-cols-xl-3">
                    <div className="col">
                      <span className="text-muted">User Name</span>
                      <span className="fw-bold d-block">{username}</span>
                    </div>
                    <div className="col">
                      <span className="text-muted">Email</span>
                      <span className="fw-bold d-block">{email}</span>
                    </div>
                    <div className="col">
                      <span className="text-muted">Phone Number</span>
                      <span className="fw-bold d-block">{phoneNumber}</span>
                    </div>
                    <div className="col">
                      <span className="text-muted">Wallet Address</span>
                      <span className="fw-bold d-block">{walletAddress}</span>
                    </div>
                    <div className="col">
                      <span className="text-muted">Withdrawal ID</span>
                      <span className="fw-bold d-block">{withdrawalRequest}</span>
                    </div>
                    <div className="col">
                      <span className="text-muted">Amount</span>
                      <span className="fw-bold d-block">{amount}</span>
                    </div>
                    <div className="col">
                      <span className="text-muted">Change Status</span>
                      <select
                        className="form-select"
                        value={status}
                        onChange={handleStatusChange}
                      >
                        <option value="">Choose...</option>
                        <option value="approved">Approve</option>
                        <option value="rejected">Reject</option>
                      </select>
                    </div>
                    <div className="col mt-3">
                      <button
                        className="btn btn-primary"
                        onClick={handleUpdateStatus}
                      >
                        Update Status
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalDetails;
